export interface HeroStory {
  kicker: string;
  headline: string;
  dek: string;
  source: string;
  updatedAt: string;
  views: string;
  comments: string;
  tags: string[];
  points: string[];
}

export const heroStory: HeroStory = {
  kicker: "今日头条 · 发酵追踪",
  headline: "「录音门」再反转：原经纪人爆节目组曾两度改稿引导舆论",
  dek: "三段合计约 9 分钟的花絮现场音频外流后，节目组、经纪公司与当事人先后发声、版本互相打架。编辑部按时间顺序还原证据链，并持续跟进最新进展、后续爆料与当事人回应动态。",
  source: "黑料编辑部 · 独家整理",
  updatedAt: "09-05 09:40 更新",
  views: "186.3万 围观",
  comments: "2.4万 讨论",
  tags: ["音频实锤待鉴定", "剪辑母带疑点", "导师改票争议"],
  points: [
    "三段音频均带现场环境音，剪辑拼接疑点待第三方声纹比对",
    "节目组连夜声明「录音经恶意剪辑」，已委托机构鉴定并称保留追责",
    "导师同场站位与出票顺序被扒出与成片不符，疑似有两版母带",
  ],
};

export interface TickerItem {
  tag: string;
  text: string;
}

export const tickerItems: TickerItem[] = [
  { tag: "突发", text: "顾言川工作室否认霸凌录音 称将就恶意剪辑走法律途径" },
  { tag: "进展", text: "「澈咖啡」加盟商联合声明曝光 直指主理人账目与分红不透明" },
  { tag: "实锤", text: "沈柏舟片约合同盖章页流出 被指存在阴阳酬劳条款" },
  { tag: "反转", text: "电竞选手阿Ke场外代练实锤 官方暂未回应禁赛传闻" },
  { tag: "爆料", text: "「星光大冒险」剪掉导师反对票 现场观众复盘站姿戳穿成片" },
  { tag: "进展", text: "老周录音第二段流出 指向选秀导师团改票动机链条" },
];

export interface TrackNode {
  time: string;
  tag: string;
  hot: boolean;
  title: string;
  body: string;
}

export const trackFeed: TrackNode[] = [
  {
    time: "09-05 09:12",
    tag: "反转",
    hot: true,
    title: "原经纪人晒第二版稿本，指节目组两度改稿",
    body: "晒出的内部流程稿显示，花絮话术曾被两次改写，均指向放大「垫底剧本」表达，与成片解说词存在多处时间戳差异。",
  },
  {
    time: "09-05 06:40",
    tag: "声明",
    hot: false,
    title: "经纪公司二更声明，口径首次松动",
    body: "声明由「坚决否认」调整为「部分花絮被断章取义」，被网友视为对音频真实性的间接让步。",
  },
  {
    time: "09-04 23:05",
    tag: "实锤",
    hot: true,
    title: "导师同框站位图热传，成片排序存疑",
    body: "观众席同机位拍摄的彩排照流出，导师改动后的实际站位与播出画面不一致，指向补录改票。",
  },
  {
    time: "09-04 21:18",
    tag: "爆料",
    hot: false,
    title: "现场工作人员匿名投稿：当日确有二次投票",
    body: "匿名账号称录制现场清场后返场重投过一次，并举出安保清场广播为佐证，暂未获官方回应。",
  },
  {
    time: "09-04 16:02",
    tag: "首发",
    hot: false,
    title: "三段现场音频首次流出",
    body: "音频首发于匿名讨论版，含导师出票前低声沟通与导演催促改票片段，成为本次发酵起点。",
  },
];

export interface RankItem {
  title: string;
  cat: string;
  heat: string;
  delta: string;
  trend: "up" | "down" | "flat";
  note: string;
  comments: string;
}

export interface RankRow {
  title: string;
  cat: string;
  note: string;
  comments: string;
}

export const rankPeriods: Record<string, RankRow[]> = {
  今日: [
    { title: "录音门二更声明口径松动，网友逐帧对照成片", cat: "娱乐", note: "新增声纹鉴定实锤楼", comments: "1.2万" },
    { title: "主理人宋夏被曝直播中用词指向加盟商", cat: "商业", note: "直播间录屏热转", comments: "9.1千" },
    { title: "阿Ke代练号战绩曝光，粉丝团倒戈", cat: "电竞", note: "关联三个账号", comments: "7.6千" },
    { title: "「星光大冒险」剪掉导师反对票", cat: "综艺", note: "现场复盘帖置顶", comments: "6.8千" },
    { title: "沈柏舟片约盖章页流出", cat: "文娱", note: "阴阳条款讨论帖", comments: "5.4千" },
    { title: "老周录音第二段指向改票动机", cat: "选秀", note: "动机链条梳理", comments: "4.3千" },
  ],
  近3日: [
    { title: "录音门持续发酵，三版口径全程复盘", cat: "娱乐", note: "编辑部时间线", comments: "2.4万" },
    { title: "澈咖啡加盟商账目风波再升温", cat: "商业", note: "联合声明跟进", comments: "1.6万" },
    { title: "沈柏舟税务争议第二轮爆料", cat: "文娱", note: "盖章页后续", comments: "1.1万" },
    { title: "选秀导师改票黑幕录音", cat: "选秀", note: "第二段曝光", comments: "9.8千" },
    { title: "电竞选手场外代练实锤", cat: "电竞", note: "官方沉默", comments: "7.2千" },
  ],
  本周: [
    { title: "综艺赛制黑幕：导师改票录音门", cat: "选秀", note: "本周最热主瓜", comments: "6.2万" },
    { title: "头部主播澈咖啡加盟商集体发声", cat: "商业", note: "账目迷雾", comments: "3.8万" },
    { title: "顶流演员片约阴阳条款风波", cat: "文娱", note: "盖章页流出", comments: "2.9万" },
    { title: "国民综艺剪辑恶意导向争议", cat: "综艺", note: "导演组回应后仍热", comments: "2.1万" },
    { title: "电竞圈代练与假赛关联疑云", cat: "电竞", note: "多方牵连", comments: "1.5万" },
  ],
};

export const rankTabs = ["今日", "近3日", "本周"];

export const rankMerged: RankItem[] = [
  { title: "录音门二更声明口径松动，网友逐帧对照成片", cat: "娱乐", heat: "186.3万", delta: "+38.2%", trend: "up", note: "声纹鉴定实锤楼持续加码", comments: "2.4万" },
  { title: "澈咖啡加盟商账目风波，主理人首度直播回应", cat: "商业", heat: "142.7万", delta: "+21.4%", trend: "up", note: "联合声明 + 直播录屏", comments: "1.6万" },
  { title: "沈柏舟片约盖章页流出，阴阳条款争议升级", cat: "文娱", heat: "121.5万", delta: "+12.8%", trend: "up", note: "第二版爆料跟进", comments: "1.1万" },
  { title: "选秀导师改票录音第二段流出", cat: "选秀", heat: "98.6万", delta: "+8.1%", trend: "up", note: "动机链条梳理帖", comments: "9.8千" },
  { title: "「星光大冒险」剪掉导师反对票", cat: "综艺", heat: "87.3万", delta: "-3.6%", trend: "down", note: "现场复盘站姿截图", comments: "7.2千" },
  { title: "电竞选手阿Ke场外代练实锤", cat: "电竞", heat: "79.8万", delta: "+5.9%", trend: "up", note: "官方暂未回应", comments: "6.1千" },
  { title: "顶流练习生早前舞台划水合集被考古", cat: "偶像", heat: "61.2万", delta: "+2.4%", trend: "flat", note: "旧瓜新炒", comments: "4.4千" },
  { title: "综艺导师团番外被扒同款剧本话术", cat: "幕后", heat: "52.7万", delta: "-6.1%", trend: "down", note: "跨节目比对帖", comments: "3.2千" },
];